export enum PlaylistType {
  WEBINAR = "1",
  KAKI_MAKAN = "2",
  SHORT_FORM = "3",
  LONG_FORM = "4",
}
